// Design tokens for the autodiag choice screen (FIX-430), scoped to this
// screen only — the global theme (src/styles/theme.jsx) stays untouched,
// same approach as src/components/rapport/rapportTokens.js.
//
// Values were measured on the COMPUTED styles of roulezjeunesse.com, not
// copied from the rj-brand-system doc. Three doc values diverge from the
// live site — the live site wins here (doc fix tracked separately):
//   - title tracking:  doc +0.01em  → live -0.02em
//   - body tracking:   doc 0.1em    → live normal
//   - button radius:   doc 30px     → live 20px
//
// #83a7c3 (grey-blue) is decorative only: 2.6:1 on white, below the 4.5:1
// WCAG AA floor. It must NEVER be used for content text or labels here —
// all body text is dark (#314959, 8.2:1).
//
// The dark CTA on the pastel card is the single accepted deviation from the
// "CTA is always green" brand rule: green #d5ff4f on pastel #e9ffcd peaks
// at 1.08:1 contrast (invisible), while #314959 reaches 8.8:1 on the card
// and 9.4:1 for its white label.
export const AUTODIAG = {
  greenPastel: '#e9ffcd',
  dark: '#314959',
  white: '#ffffff',
  linkBlue: '#595fe7', // theme.colors.blue.electric — same blue as the funnel back link
  border: '#d3dde6',

  radiusCard: '20px',
  radiusButton: '20px',

  titleTracking: '-0.02em',
  bodyTracking: 'normal',

  // Badge « Nouveau » geometry: 36px tall, absolutely positioned astride the
  // card's top edge — 14px above it, 22px inside. Card padding-top and grid
  // margin-top are calibrated on those 22px; shrinking them makes the badge
  // bite into the title.
  badgeHeight: 36,
  badgeOverhang: 14,
  cardPadTopDesktop: 36,
  cardPadTopMobile: 32,
  gridMarginTopDesktop: 32,
  gridMarginTopMobile: 30,

  // Card feet align through a fixed min-height (labels may differ in length).
  cardActMinHeight: 52,

  // Shared preview height so both cards keep the same metrics side by side.
  // Measured against the fold budget in the real tunnel (CTA bottom ≤ 640px
  // on a 660px useful viewport) — grow it and the CTAs sink below the fold.
  previewHeight: 116,
};

export { TITLE_FONT } from '../rapport/rapportTokens';

export default AUTODIAG;
